'use strict';

angular.module('myConsultApp').filter('petage', function () {
  return function (age) {
    if (age >= 12) {
      age = Math.floor(age / 12);
    } else {
      age = age + 'm';
    }
    return age;
  };
});
